/**
 * @generated SignedSource<<26d063313acff198955f1e9e23296679>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SeoRouteType = "ALIAS" | "PERMANENT_REDIRECT" | "REDIRECT";
import { FragmentRefs } from "relay-runtime";
export type SeoRouteEditForm_seoRoute$data = {
  readonly id: string;
  readonly sourceUrl: string | null;
  readonly targetUrl: string | null;
  readonly type: SeoRouteType;
  readonly " $fragmentType": "SeoRouteEditForm_seoRoute";
};
export type SeoRouteEditForm_seoRoute$key = {
  readonly " $data"?: SeoRouteEditForm_seoRoute$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeoRouteEditForm_seoRoute">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeoRouteEditForm_seoRoute",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetUrl",
      "storageKey": null
    }
  ],
  "type": "SeoRoute",
  "abstractKey": null
};

(node as any).hash = "8f89049b734e6e4d57bc68680c2e82ac";

export default node;
